module.exports = __webpack_public_path__ + "static/media/icon_list.a42677c4.png";